export enum TemplateEnum {
    DEFAULT = 1,
    B2B2C = 2
}
